import getTailwindUtility from "./getTailwindUtility";

const colors = getTailwindUtility("colors");

const getTailwindColor = color => {
  if (typeof colors[color] === "string") {
    return colors[color];
  }

  if (typeof color === "string") {
    const split = color.split(".");

    if (split.length > 1) {
      return split.reduce((obj, key) => obj[key], colors);
    }
  }

  return color;
};

export default getTailwindColor;
